/**
 * SEO 配置 - models (Dansk)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Fysik-nøjagtig AI videogenerator | WeryAI',
        description: 'Generer realistiske, fysik-nøjagtige AI videoer med OpenAI Sora 2 med synkroniseret lyd og narrativ konsistens.',
        keywords: 'Sora 2, OpenAI Sora, videomodel, realistisk AI video, tekst til video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 | WeryAI',
        description: 'Experience WeryAI Image 2.0 on WeryAI.',
        keywords: 'WeryAI Image 2.0, AI, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 | xAI | WeryAI',
        description: 'Experience Grok-2 by xAI on WeryAI.',
        keywords: 'Grok-2, xAI, AI, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Filmisk AI videogenerator | WeryAI',
        description: 'Kling 2.5 Turbo skaber filmiske AI videoer med avanceret linsestyring, følelsesmæssige udtryk og jævn fysik.',
        keywords: 'Kling 2.5 Turbo, Kling AI, filmisk AI video, linsestyring AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - Avanceret AI-videogenerator og -redigering | WeryAI',
        description: 'Runway Gen-4 genererer realistiske, konsistente AI-videoer med dybere promptforståelse og smarte redigeringsværktøjer. Prøv det gratis på WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, AI-videogenerator, tekst til video, billede til video, AI-videoredigering, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Videogenerator - Avanceret videoproduktion | WeryAI',
        description: 'Generer avancerede AI videoer med Hailuo AI på WeryAI. Med state-of-the-art bevægelsesstyring og realistisk rendering.',
        keywords: 'Hailuo AI, MiniMax, AI videogenerator, bevægelsesstyring, realistisk video, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance AI videogenerator - Dans og bevægelse skabelse | WeryAI',
        description: 'Seedance AI videogenerator - Dans og bevægelse skabelse on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro billedgenerering | WeryAI',
        description: 'Nano Banana Pro - Google Gemini 3.0 Pro billedgenerering on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana_pro, AI, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash højhastigheds tegning | WeryAI',
        description: 'Google Nano Banana - Gemini 2.5 Flash højhastigheds tegning on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana, AI, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI billedgenerator - Top open source tegnemodel | WeryAI',
        description: 'FLUX AI billedgenerator - Top open source tegnemodel on WeryAI. Fast and high-quality results.',
        keywords: 'flux, AI, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Professionel AI tegneforbedring | WeryAI',
        description: 'FLUX.1 Kontext - Professionel AI tegneforbedring on WeryAI. Fast and high-quality results.',
        keywords: 'flux_kontext, AI, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Avanceret tekst-til-billede diffusionsmodel fra Google | WeryAI',
        description: 'Google Imagen 4 - Avanceret tekst-til-billede diffusionsmodel fra Google on WeryAI. Fast and high-quality results.',
        keywords: 'imagen, AI, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Open source tekst renderingsmodel fra Alibaba | WeryAI',
        description: 'Qwen Image - Open source tekst renderingsmodel fra Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'qwen_image, AI, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 billedgenerering - High fidelity billedmodel fra Alibaba | WeryAI',
        description: 'Wan 2.5 billedgenerering - High fidelity billedmodel fra Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - ByteDance batch 4K tegnemodel | WeryAI',
        description: 'Seedream 4.0 - ByteDance batch 4K tegnemodel on WeryAI. Fast and high-quality results.',
        keywords: 'seendream, AI, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - ByteDance alt-i-en AI billedskabelsesmodel | WeryAI',
        description: 'Dreamina 4.0 - ByteDance alt-i-en AI billedskabelsesmodel on WeryAI. Fast and high-quality results.',
        keywords: 'dreamina, AI, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - ByteDance Flagskib AI Billedgenereringsmodel | WeryAI',
        description: 'Seedream 4.5 er ByteDances nyeste flagskibs AI-billedmodel med fokus på præcis typografi-rendering og multi-billed fusion med 4K ultra HD output. Prøv gratis på WeryAI.',
        keywords: 'Seedream 4.5, AI billedgenerering, typografi-rendering, billedfusion, ByteDance, 4K kvalitet, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Top kunstnerisk æstetik AI tegning | WeryAI',
        description: 'Midjourney - Top kunstnerisk æstetik AI tegning on WeryAI. Fast and high-quality results.',
        keywords: 'midjourney, AI, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI Video Generator - Skab Biografkvalitet Videoer | WeryAI',
        description: 'Skab fantastiske videoer med Runway Gen-4.5 på WeryAI. Hybrid autoregressiv-diffusions arkitektur for præcis fysik simulation og tidsmæssig konsistens.',
        keywords: 'Runway Gen-4.5, AI video generator, biografkvalitet AI video, fysik simulation, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI Video Generator - Høj Kvalitet Video Skabelse | WeryAI',
        description: 'Generer høj kvalitet videoer med Kling 2.6 Pro på WeryAI. Native audiovisuel generering, biografkvalitet 1080p, fremragende prompt overholdelse.',
        keywords: 'Kling 2.6 Pro, AI video generator, høj kvalitet AI video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video Generator - Præcis kamera kontrol og frame vejledning | WeryAI',
        description: 'Generer biografkvalitet AI videoer med Dreamina 3.0 (Jimeng 3.0) på WeryAI. Præcis start/slut frame kontrol, professionelle kamerabevægelser og 1080p høj-dynamisk video generering.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, AI video generator, kamera kontrol, start slut frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI Video Generator - Kreativ Video Generering | WeryAI',
        description: 'Frigør din kreativitet på WeryAI med Kling O1 AI video generator. Perfekt til at generere fantasifuldt og unikt videoindhold.',
        keywords: 'Kling O1, AI video generator, kreativ AI video, Kling AI, WeryAI',
    },
}
